import React from "react";
import { Tabs } from "antd";
import MyEvaluation from "./components/MyEvaluation";
import styles from "./index.module.scss";
import ReceivedEvaluation from "./components/ReceivedEvaluation";

export default function TabEvaluationList() {
    return (
        <Tabs className={styles.root} animated={false}>
            <Tabs.TabPane key="1" tab="我评价的">
                <MyEvaluation />
            </Tabs.TabPane>

            <Tabs.TabPane key="2" tab="评价我的">
                <ReceivedEvaluation />
            </Tabs.TabPane>
        </Tabs>
    );
}
